import { getSharingDataFromLink } from 'owa-link-data';
import AttachmentPermissionLevel from 'owa-service/lib/contract/AttachmentPermissionLevel';
import { SharingData } from 'owa-sharing-data';

export function shouldCheckPermForLink(linkId: string) {
    const sharingData: SharingData = getSharingDataFromLink(linkId);
    return (
        sharingData &&
        sharingData.sharingInfo.getSharingInfoSucceeded &&
        (sharingData.currentPermissionLevel === AttachmentPermissionLevel.None ||
            sharingData.currentPermissionLevel === AttachmentPermissionLevel.Edit ||
            sharingData.currentPermissionLevel === AttachmentPermissionLevel.View)
    );
}
